// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1QZpH","inputWrap":"styles_inputWrap__3PA2q","input":"styles_input__1RxNC"};